/**
 * Shared circular user avatar. Falls back to the brand logo when the
 * user hasn't uploaded a face photo yet.
 *
 * Accepts either a full user object (`user.picture`) or a raw `src` string.
 */
const SIZE_CLS = {
  xs: "h-7 w-7 text-[11px]",
  sm: "h-9 w-9 text-xs",
  md: "h-12 w-12 text-sm",
  lg: "h-16 w-16 text-base",
  xl: "h-24 w-24 text-lg",
};

export default function Avatar({
  src,
  user,
  size = "md",
  className = "",
  testid,
  alt,
}) {
  const picture = src ?? user?.picture ?? null;
  const fallback = "/brand-logo.jpg";
  const url = picture || fallback;
  const isFallback = !picture;
  const label =
    alt || user?.name || user?.email || (isFallback ? "Default avatar" : "Avatar");

  return (
    <span
      className={`inline-flex ${SIZE_CLS[size] || SIZE_CLS.md} items-center justify-center rounded-full overflow-hidden bg-slate-100 ring-1 ring-slate-200 ${className}`}
      data-testid={testid}
      data-avatar-fallback={isFallback ? "true" : "false"}
    >
      <img
        src={url}
        alt={label}
        className={`h-full w-full ${isFallback ? "object-contain p-1" : "object-cover"}`}
        draggable={false}
        onError={(e) => {
          if (e.currentTarget.src !== window.location.origin + fallback) {
            e.currentTarget.src = fallback;
          }
        }}
      />
    </span>
  );
}
